import React, { useRef, memo } from "react";
import PropTypes from "prop-types";
import { UncontrolledTooltip } from "reactstrap";

import PointerEvents from "stylesheets/utilities/pointerEvents.module.scss";
import { matchedPhrase } from "./styles/MatchedPhraseText.module.scss";

const MatchedPhraseText = ({ text, matchedPhraseStrings }) => {
  const textRef = useRef();

  return (
    <React.Fragment>
      <span ref={textRef} className={matchedPhrase}>
        {text}
      </span>
      <UncontrolledTooltip className={PointerEvents.none} placement="top" target={textRef} trigger="hover">
        {matchedPhraseStrings.join(", ")}
      </UncontrolledTooltip>
    </React.Fragment>
  );
};

MatchedPhraseText.propTypes = {
  text: PropTypes.string.isRequired,
  matchedPhraseStrings: PropTypes.arrayOf(
    PropTypes.string
  ).isRequired
};

export default memo(MatchedPhraseText);
